module.exports = __webpack_public_path__ + "assets/img/logitech-landingpage-and-website-internal.a6584b9e.jpg";